import map_marker from './map_marker';
import fallback from './fallback';
import pc from './pc-code';
import pca from './pca-code';
import mapimage from './assets/map';

export default {
  map_marker,
  fallback,
  pc,
  pca,
  ...mapimage,
}